type SelectableOption = { selected?: boolean };

// Returns a copy of `options` with the option matching the current value flagged
// `selected`. When nothing matches, a synthesized "custom" option (built by
// `createCustomOption`) is appended and flagged instead — so a stored value outside the
// preset list still shows up as the selected choice. Never mutates the input.
export function withSelectedOption<T extends SelectableOption>(
  options: T[],
  matchesCurrent: (option: T) => boolean,
  createCustomOption: () => T,
): T[] {
  const data = options.map((option) => ({ ...option }));
  const current = data.find(matchesCurrent);

  if (current) {
    current.selected = true;
    return data;
  }

  return [...data, { ...createCustomOption(), selected: true }];
}
